import type { SystemColorType, ThemeType } from '../../util/types';
import type { StudentAssessmentStateType } from '../types';
import type { ThemeProps } from 'styled-components';
import type { ChangeEventHandler } from 'react';
import { getPolishedColors } from '../../util/styled';
import styled, { css } from 'styled-components';
import { Translate } from '@whizz/react-i18n';
import { ChoiceGroup } from '../../components';

const statuses: Record<StudentAssessmentStateType, {
  label: string,
  color: SystemColorType,
  rank: number
}> = {
  'not_logged_in': {
    label: 'NOT_LOGGED_IN',
    color: 'error',
    rank: 0,
  },
  'not_started': {
    label: 'NOT_STARTED',
    color: 'error',
    rank: 1,
  },
  'started': {
    label: 'STARTED',
    color: 'warning',
    rank: 2,
  },
  'complete': {
    label: 'COMPLETE',
    color: 'success',
    rank: 3,
  },
};

const ResetAssessmentCheckBox = ( { id, checked = false, label = '', onClick }: { id: number | string, checked?: boolean, label?: string, onClick: ChangeEventHandler<HTMLInputElement> }): JSX.Element => (
  <div className={'flex items-center'}>
    <ChoiceGroup id={`reset-${id}`} label={label} checked={checked} onChange={onClick} />
  </div>
);

const getColors = (props: ThemeProps<ThemeType> & { $color: SystemColorType }) => {
  const colors = getPolishedColors(props);
  return css`
    background: ${colors.light.color};
    color: ${colors.light.readable};
  `;
};

const StudentStatusStyled = styled('div')<{
  $color: SystemColorType
}>`
  ${(props) => getColors(props)}
`;

const TranslateWithSpan = ({ i18nKey, values }: { i18nKey: string, values: any }) => {
  return (
    <Translate i18nKey={i18nKey} values={values}>
      {[ <span className={'font-normal'} /> ]}
    </Translate>
  );
};

const StudentStatus = ({ status, days }: { status: StudentAssessmentStateType, days: number | null }): JSX.Element => {
  const { color, label } = statuses[status];
  return (
    <div className={'bg-white rounded'}>
      <StudentStatusStyled $color={color} className={'rounded py-0.5 px-2 lg:py-3 w-full font-bold whitespace-nowrap'}>
        <TranslateWithSpan i18nKey={`pages.RESET_ASSESSMENTS.STATUS.${label}`} values={{ count: days }} />
      </StudentStatusStyled>
    </div>
  );
};

export { statuses, ResetAssessmentCheckBox, StudentStatus };
